import { Quote } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import SpotlightCard from "@/components/SpotlightCard";
import { TESTIMONIALS, IMAGES } from "@/data/content";

const Results = () => (
  <section
    id="results"
    data-testid="results-section"
    className="relative border-t border-[#27272A] bg-[#0a0a0c] py-24 sm:py-32"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead
        eyebrow="Member Results"
        title="Angles don't lie. Neither do the men who put in the cycles."
        testId="results-heading"
      />

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <SpotlightCard testId={`testimonial-card-${i}`} className="h-full">
              <div className="flex h-full flex-col p-7 sm:p-8">
                <Quote size={20} className="text-[#CC0A14]" />
                <p className="mt-6 flex-1 text-sm leading-relaxed text-zinc-300">
                  "{t.quote}"
                </p>
                <div className="mt-8 border-t border-[#27272A] pt-6">
                  <p className="font-syne text-4xl font-extrabold text-[#CC0A14]">{t.metric}</p>
                  <p className="mt-1 font-jb text-[10px] uppercase tracking-[0.18em] text-zinc-500">
                    {t.metricLabel}
                  </p>
                </div>
                <div className="mt-6 flex items-center gap-3">
                  <img
                    src={IMAGES[t.avatar]}
                    alt={t.name}
                    loading="lazy"
                    className="h-10 w-10 border border-[#27272A] object-cover grayscale"
                  />
                  <div>
                    <p className="text-sm font-semibold text-white">{t.name}</p>
                    <p className="font-jb text-[10px] uppercase tracking-[0.16em] text-zinc-500">
                      {t.meta}
                    </p>
                  </div>
                </div>
              </div>
            </SpotlightCard>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="relative mt-6 overflow-hidden border border-[#27272A]">
          <img
            src={IMAGES.gymDark}
            alt="Disciplined training in dark gym"
            loading="lazy"
            className="h-64 w-full object-cover grayscale sm:h-80"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#080808] via-[#080808]/40 to-transparent" />
          <div className="absolute inset-0 flex items-center">
            <p className="max-w-md px-7 font-syne text-xl font-bold leading-snug text-white sm:px-10 sm:text-2xl">
              Discipline compounds.{" "}
              <span className="text-[#CC0A14]">Twelve weeks is nothing.</span> The face is forever.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Results;
